import React, { useState } from 'react';

const projects = [
  {
    title: 'PLN Substation Jakarta',
    category: 'Power Utility',
    image: 'AIS Installation'
  },
  {
    title: 'Mining Site Kalimantan',
    category: 'Mining',
    image: 'GIS Installation'
  },
  {
    title: 'Cement Factory Jawa Barat',
    category: 'Manufacturing',
    image: 'Metal Clad Installation'
  }
];

const filters = ['All', 'Power Utility', 'Mining', 'Manufacturing'];

const Projects = () => {
  const [activeFilter, setActiveFilter] = useState('All');

  const filteredProjects = activeFilter === 'All'
    ? projects
    : projects.filter(p => p.category === activeFilter);

  return (
    <section className="projects section" id="projects">
      <div className="container">
        <div className="projects-header">
          <div>
            <span className="section-subtitle">Our Portfolio</span>
            <h2 className="section-title">Proyek Terbaru</h2>
          </div>
          <div className="projects-filters">
            {filters.map((filter) => (
              <button
                key={filter}
                className={`filter-btn ${activeFilter === filter ? 'active' : ''}`}
                onClick={() => setActiveFilter(filter)}
              >
                {filter}
              </button>
            ))}
          </div>
        </div>

        <div className="projects-grid">
          {filteredProjects.map((project, index) => (
            <div className="project-card" key={index}>
              <div className="project-image">
                {project.image}
              </div>
              <div className="project-overlay">
                <span className="project-category">{project.category}</span>
                <h3 className="project-title">{project.title}</h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
